import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { CardHeader } from 'reactstrap';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import { getConfiguracaoMatrizRisco } from '../../../../services/ConfiguracaoMatrizRiscoService';

const useStyles = makeStyles({
    root: {
        minWidth: 200,
    },
    title: {
        fontSize: 14,
    },
    input: {
        width: 40,
    },
    header: {
        textAlign: 'center',
    },
});

const NivelDeRisco = ({ stateless }) => {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardHeader className={classes.header}>Nível de Risco</CardHeader>
            <CardContent>
                <InputListItem stateless={stateless} />
            </CardContent>
        </Card>
    );
};

const item = {
    alto: 'Alto',
    medio: 'Médio',
    baixo: 'Baixo',
    somenteVenda: 'Somente Venda',
    estoqueSeguranca: 'Estoque de Segurança',
    vendaFutura: 'Venda Futura',
};

const initState = { alto: '', medio: '', baixo: '', test: '', estoqueSeguranca: false, vendaFutura: false };
const name = 'nivelDeRisco';

const InputListItem = ({ stateless }) => {
    const classes = useStyles();

    const [securityStockChecked, setSecurityStockChecked] = React.useState(false);
    const [isFutureSale, setFutureSale] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const [value, setValue] = React.useState(initState);
    const [niveisRisco, setNiveisRisco] = React.useState([]);

    const handleToggle = (_) => {
        if (!checked) {
            setValue(initState);
        }
        if (isFutureSale || securityStockChecked) {
            setFutureSale(false);
            setSecurityStockChecked(false);
        }
        setChecked(!checked);
    };

    const handleFutureSale = (_) => {
        if (checked || securityStockChecked) {
            setChecked(false);
            setSecurityStockChecked(false);
        }
        setFutureSale(!isFutureSale);

        const newValue = { ...value };
        newValue.vendaFutura = !isFutureSale;
        setValue(newValue);
    };

    const handleSecurityStockToggle = (_) => {
        if (checked || isFutureSale) {
            setChecked(false);
            setFutureSale(false);
        }
        setSecurityStockChecked(!securityStockChecked);

        const newValue = { ...value };
        newValue.estoqueSeguranca = !securityStockChecked;
        setValue(newValue);
    };

    const handleChange = (name, e) => {
        const newValue = { ...value };

        const v = Number(e.target.value || NaN);

        if (!e.target.value || v <= 100) newValue[name] = v || '';

        setValue(newValue);
    };

    useEffect(() => {
        const fetch = async () => {
            const configs = await getConfiguracaoMatrizRisco();
            setNiveisRisco(configs);
        };

        fetch();
    }, []);

    useEffect(() => {
        if (checked) {
            setSecurityStockChecked(false);
            return stateless.setValue(name, checked);
        }

        stateless.setValue(name, value);
    }, [checked, value]); // eslint-disable-line react-hooks/exhaustive-deps

    const { somenteVenda, estoqueSeguranca, vendaFutura } = item;

    return (
        <List>
            {niveisRisco &&
                niveisRisco.length > 0 &&
                niveisRisco.map((item) => {
                    return (
                        <ListItem key={item.nivelRisco} role={undefined} dense>
                            <ListItemIcon>
                                <Input
                                    className={classes.input}
                                    value={value[item.nivelRisco]}
                                    onChange={(v) => handleChange(item.nivelRisco, v)}
                                />
                            </ListItemIcon>
                            <ListItemText id={`checkbox-list-label-${item.nivelRisco}`} primary={item.nivelRisco} />
                        </ListItem>
                    );
                })}
            <ListItem key={somenteVenda} role={undefined} dense button onClick={handleToggle}>
                <ListItemIcon>
                    <Checkbox edge='start' checked={checked} tabIndex={-1} disableRipple />
                </ListItemIcon>
                <ListItemText id={`checkbox-list-label-${somenteVenda}`} primary={somenteVenda} />
            </ListItem>
            <ListItem key={estoqueSeguranca} role={undefined} dense button onClick={handleSecurityStockToggle}>
                <ListItemIcon>
                    <Checkbox edge='start' checked={securityStockChecked} tabIndex={-1} disableRipple />
                </ListItemIcon>
                <ListItemText id={`checkbox-list-label-${estoqueSeguranca}`} primary={estoqueSeguranca} />
            </ListItem>
            <ListItem key={vendaFutura} role={undefined} dense button onClick={handleFutureSale}>
                <ListItemIcon>
                    <Checkbox edge='start' checked={isFutureSale} tabIndex={-1} disableRipple />
                </ListItemIcon>
                <ListItemText id={`checkbox-list-label-${vendaFutura}`} primary={vendaFutura} />
            </ListItem>
        </List>
    );
};

export default NivelDeRisco;
